
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Auth from "@/lib/common/auth";
import { Template } from "@/lib/model/template/template";
import Editor from "@/components/editor/email-editor.vue";
import { ElForm } from "element-ui/types/form";
import Pop from "../../ai-builder/components/blue-pop.vue";
import _ from "lodash-es";
@Component({ components: { Editor, Pop } })
export default class EmailDialog extends Vue {
  @Prop({}) exam!: any;
  @Prop({}) onlyShow!: boolean;
  @Prop({}) tId!: number;
  title = "新建邮件通知模板";
  template = new Template();
  content = "";
  rules = {
    name: [{ required: true, message: "请输入名称", trigger: "change" }],
    emailSubject: [
      { required: true, message: "请输入标题", trigger: "change" }
    ],
    env: [{ required: true, message: "请选择类型", trigger: "change" }],
    emailName: [{ required: true, message: "请输入发件人", trigger: "change" }],
    emailContentHtml: [
      { required: true, message: "请输入模板内容", trigger: "change" }
    ]
  };
  tagList = [
    { name: "{候选人姓名}" },
    { name: "{公司名称}" },
    { name: "{面试名称}" },
    { name: "{面试链接}" },
    { name: "{面试二维码}" },
    { name: "{面试有效期}" },
    { name: "{定向邀请链接有效期}" },
    { name: "{答题时间限制}" }
  ];
  tagListPass = [
    { name: "{候选人姓名}" },
    { name: "{公司名称}" },
    { name: "{面试名称}" },
    { name: "{面试结果链接}" }
  ];
  tagListFailed = [
    { name: "{候选人姓名}" },
    { name: "{公司名称}" },
    { name: "{面试名称}" },
    { name: "{面试结果链接}" }
  ];
  tagListJob = [
    { name: "{候选人姓名}" },
    { name: "{公司名称}" },
    { name: "{职位组展示标题}" },
    { name: "{职位组链接}" },
    { name: "{职位组二维码}" }
  ];

  get tagListFilter() {
    const env = this.template.env;
    return env === 3
      ? this.tagListFailed
      : env === 2
      ? this.tagListPass
      : env === 20
      ? this.tagListJob
      : env === 4
      ? [...this.tagList, { name: "{面试结果链接}" }]
      : this.tagList;
  }

  created() {
    this.template.type = 2;
    if (this.tId) {
      //编辑
      Template.get({ templateId: this.tId }).then(res => {
        if (res.data.code === 0) {
          this.template = new Template().assign(res.data.data);
        }
      });
      this.title = this.onlyShow ? "查看邮件通知模板" : "编辑邮件通知模板";
    } else {
      //新建
    }
  }
  mounted() {
    //
  }
  addTag(it: any) {
    (this.$refs.emailRef as any)?.insertHtml(
      // `<i class='noEdit'>${it.name}</i>`
      it.name
    );
  }

  ok() {
    (this.$refs.form as ElForm).validate(res => {
      if (res) {
        if (this.tId) {
          Template.update(this.template).then(res => {
            if (res.data.code === 0) {
              this.$emit("ok");
            }
          });
        } else {
          Template.create(this.template).then(res => {
            if (res.data.code === 0) {
              this.$emit("ok");
            }
          });
        }
      }
    });
  }
  templateEnvChange(value: any) {
    if (!this.template.emailContentHtml) {
      return;
    }
    let list = this.template.emailContentHtml.split("{");
    switch (value) {
      case 20:
        list = list.map(el => {
          el = el
            .replace("面试名称}", "")
            .replace("面试链接}", "")
            .replace("面试有效期}", "")
            .replace("定向邀请链接有效期}", "")
            .replace("答题时间限制}", "")
            .replace("面试结果链接}", "")
            .replace("面试二维码}", "");
          if (el.indexOf("}") > -1) {
            el = "{" + el;
          }
          return el;
        });
        this.template.emailContentHtml = list.join("");
        break;
      case 3:
      case 2:
      case 4:
        list = list.map(el => {
          el = el
            .replace("面试名称}", "")
            .replace("面试链接}", "")
            .replace("面试二维码}", "")
            .replace("面试有效期}", "")
            .replace("定向邀请链接有效期}", "")
            .replace("答题时间限制}", "")
            .replace("职位组展示标题}", "")
            .replace("职位组链接}", "")
            .replace("职位组二维码}", "");
          if (el.indexOf("}") > -1) {
            el = "{" + el;
          }
          return el;
        });
        this.template.emailContentHtml = list.join("");
        break;
      default:
        list = list.map(el => {
          el = el
            .replace("职位组展示标题}", "")
            .replace("职位组展示标题}", "")
            .replace("职位组链接}", "")
            .replace("面试结果链接}", "")
            .replace("职位组二维码}", "");
          if (el.indexOf("}") > -1) {
            el = "{" + el;
          }
          return el;
        });
        this.template.emailContentHtml = list.join("");
        break;
    }
  }

  //关闭
  close() {
    this.$emit("cancelMessage", false);
  }
}
